import React from 'react';
import { Navigate } from 'react-router-dom';

const AmbientTemperaturePage: React.FC = () => {
  return <Navigate to="/analytics/water-temperature" replace />;
};

export default AmbientTemperaturePage;
